export function validateEmail(email: string): boolean {
    let re = /\S+@\S+\.\S+/;
      return re.test(email);
};